import { FlexProps, Flex } from '@chakra-ui/react'

const DropTitle = ({ children, ...props }: FlexProps) => {
  const { color, ...rest } = props
  return (
    <Flex
      position={'relative'}
      alignItems={'center'}
      width={'100%'}
      minW={'100%'}
      pl={3}
      mb="10px"
      color={color}
      {...rest}
    >
      {children}
    </Flex>
  )
}

export default DropTitle
